
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class CollectionMasterDialog extends Serenity.EntityDialog<CollectionMasterRow, any> {
        protected getFormKey() { return CollectionMasterForm.formKey; }
        protected getIdProperty() { return CollectionMasterRow.idProperty; }
        protected getLocalTextPrefix() { return CollectionMasterRow.localTextPrefix; }
        protected getNameProperty() { return CollectionMasterRow.nameProperty; }
        protected getService() { return CollectionMasterService.baseUrl; }
        protected getInsertPermission() { return CollectionMasterRow.insertPermission; }
        protected getUpdatePermission() { return CollectionMasterRow.updatePermission; }
        protected getDeletePermission() { return CollectionMasterRow.deletePermission; }
        protected useViewMode() { return true; }

        protected form = new CollectionMasterForm(this.idPrefix);

        constructor() {
            super();
            this.form.AttributeCode.changeSelect2(e => {
                if (id != undefined) {
                    var id = AttributeMasterRow.getLookup().items.filter(x => x.AttributeCode.toUpperCase() == this.form.AttributeCode.value)[0];
                    if (id.AttributeId != null || id.AttributeId > 0) {
                        Q.notifyError("Duplicate Collection " + this.form.AttributeCode.value);
                        this.form.AttributeCode.value = "";
                        return;

                    }
                }
                else {
                    this.form.AttributeCode.value = this.form.AttributeCode.value.toUpperCase();
                }
            })
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            return btns;
        }

        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            var x = this.form.AttributeName.value;
            alert('' + x);
            var id = CollectionMasterRow.getLookup().items.filter(x => x.AttributeName == this.form.AttributeName.value)[0];
            alert('' + id.AttributeId);
            //var refid = CommonAttributesRow.getLookup().items.filter(x => x.CollectionId == id.AttributeId)[0];
            var refid: Common.CommonAttributeResponse;
            OMS.CommonAttributesService.GetProductATB({
                CollectionId: id.AttributeId
            }, response => {
                refid = response;
            }, { async: false });
            if (refid != null) {
                if (refid.AttributeId != null || refid.AttributeId > 0) {
                    Q.alert("Collection is in use, Cannot delete");
                    return;

                }
            } else {
                CollectionMasterService.Delete(
                    {

                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }


        }
    }
}